'use strict';

var PromiseSpec = require('./detail/promise');
var CallbackSpec = require('./detail/callback');
var SyncSpec = require('./detail/sync');

module.exports.PromiseSpec = PromiseSpec;
module.exports.CallbackSpec = CallbackSpec;
module.exports.SyncSpec = SyncSpec;
